const PREFIX = "mf_runtime_";

/**
 * Eine Annotation, die auf Buttons zum PDF-Generieren erwartet wird. Wird verwendet um zu ermitteln, wie das generierte Dokument heißen soll.
 */
export const DATEINAME = PREFIX + "dateiname";

/**
 * Eine Annotation, die auf Buttons zum PDF-Generieren erwartet wird. Wird verwendet um zu ermitteln, welches Format die Dateiname des generierten Dokuments haben soll.
 */
export const DATEINAME_FORMAT = PREFIX + "dateiname_format";

export const DATEINAME_FORMAT_STAMMDATEN = PREFIX + "dateiname_format_SD";

/**
 * Eine Annotation, die auf Buttons zum PDF-Generieren erwartet wird. Wird verwendet um zu ermitteln, welches Printmodel verwendet werden soll.
 */
export const PRINTMODEL_ID_NAME = PREFIX + "printModelId";

/**
 * Annotation für Clickable Links
 */
export const LINKS_MARKER = PREFIX + "links_marker";

/**
 * Diese Annotation kann auf Form-Modelle eingesetzt werden.
 * Wird im Custom Code angesprochen, um die Textbausteine Verwaltung für die Bescheid-Erstellung zu bedienen.
 * Der Wert gibt an welche Kategorie in der Textbausteine Verwaltung geladen werden soll.
 */
export const BESCHEID_ERSTELLER_MARKER = PREFIX + "bescheid_erstellen_marker";

/**
 * Diese Annotation kann auf Form-Modelle eingesetzt werden.
 * Wird im Custom Code angesprochen, um die Textbausteine Verwaltung für Information Nachforderung zu bedienen.
 * Der Wert gibt an welche Kategorie in der Textbausteine Verwaltung geladen werden soll.
 */
export const NACHFORDERUNG_MARKER = PREFIX + "nachforderung_marker";

export const TEXTBAUSTEINE_KATEGORIE = PREFIX + "textbausteine_kategorie";

/**
 * Diese Annotation kann auf Form-Modelle eingesetzt werden.
 * Wird im Custom Code angesprochen, um den Button für die Anzeige der Textbausteine-Verwaltung anzuzeigen.
 */
export const TEXTBAUSTEINE_ANZEIGEN = PREFIX + "textbausteine_anzeigen";

/**
 * Diese Annotation kann auf Felder von Dokument-Modellen eingesetzt werden.
 * Der Wert der Annotation bestimmt die Bezeichner einer External Enumeration.
 * Wenn ein Feld damit markiert ist, dann soll der Wert des Feldes
 * zur jeweiligen External Enumeration hinzugefügt werden.
 */
export const EXTERNAL_ENUMERATION = PREFIX + "externalEnumeration";

/**
 * Existierende Werte für External Enumeration Annotation
 */
export const EXTERNAL_ENUMERATION_SOURCE = {
	GENERATED_DOCUMENT: "generiertesDokument",
	FILE_UPLOAD_DATA: "document_upload"
};

/**
 * Diese Annotation kann für Button-Enablements verwendet werden für Form- und Overview-Modelle.
 * Die Annotation hat folgende mögliche Properties:
 *
 * <p>path (required): Der Pfad zu dem abhängigen Feld im Dokumenten-Modell.
 * display: Der Typ für die Anzeige in der UI. Mögliche Werte: hide, disable (hide > display). Der default ist hide.
 * negation: Boolean für die Steuerung einer Negation. Der default ist false.
 *
 * <p>Mit dem Trennzeichen "|" können mehrere Enablements verkettet werden.
 *
 * <p>Beispiele:
 * <ul>
 *     <li>/root/path/to/element</li>
 *     <li>A12PATH(toElement=#element)</li>
 *     <li>path=/root/path/to/element,display=hide,negation=false</li>
 *     <li>path=A12PATH(toElement=#element),display=hide,negation=false</li>
 *     <li>path=A12PATH(toElement=#element),display=hide,negation=false
 *     |path=A12PATH(toElement=#anotherElement),display=disable,negation=true</li>
 * </ul>
 */
export const BUTTON_DEPENDENT_ENABLEMENT = PREFIX + "dependent_enablement";

/**
 * Diese Annotation markiert im Form-Model Elemente, die für den E-Mail-Versand notwendig sind.
 *
 * <p>Das Element, welches das Event für den E-Mail-Versand triggert, muss mit der Annotation markiert werden
 * und der Wert der Annotation muss das Modul sein, in dem sich die Felder für den E-Mail-Versand befinden.
 * Das Element muss außerdem das "event_send_mail" auslösen.
 *
 * <p>Die Felder im Form-Model, die für den E-Mail-Versand notwendig sind, müssen ebenfalls markiert werden
 * und folgende Werte enthalten:
 * <ul>
 *  <li>Empfänger -> empfaenger</li>
 *  <li>Betreff -> betreff</li>
 *  <li>Nachricht -> nachricht</li>
 *  <li>Versand-Datum -> absendedatum</li>
 *  <li>Anhang -> anhang</li>
 * </ul>
 *
 * <p>Limitationen:
 * <ul>
 * <li>Aktuell ist es nur möglich einen Empfänger und einen Anhang zu definieren.</li>
 * <li>Beim Modellieren muss darauf geachtet werden, dass es innerhalb eines Modules eindeutige Zuordnungen
 * der Annotations gibt. Gibt es beispielsweise zweimal recifvpient, dann wird nur der erste genommen.</li>
 * </ul>
 */
export const EMAIL_VERSAND = PREFIX + "email";

// Value für mf_runtime_email Annotation

export const EMAIL_EMPFAENGER = "empfaenger";
export const EMAIL_EMPFAENGER_TYP = "empfaengerTyp";
export const EMAIL_BETREFF = "betreff";
export const EMAIL_NACHRICHT = "nachricht";
export const EMAIL_ABSENDEDATUM = "absendedatum";
export const EMAIL_ANHANG = "anhang";
export const EMAIL_KONTAKLISTE_APPIDS = PREFIX + "kontaktliste_appids";
export const EMAIL_EMPFAENGER_GROUP_PATH = PREFIX + "empfaenger_group_path";

export const EMAIL_EMPFAENGER_REPEAT = PREFIX + "email";
export const EMAIL_EMPFAENGER_REPEAT_TYP = "empfaengerGroup";
/**
 * Möglicher Wert der Annotation modulf_AliasForPath.
 * Alias für den Pfad zur E-Mail-Adresse, die für Nachforderungen verwendet werden soll.
 * Wird durch Fachverfahrens-Portal Custom Code ausgewertet.
 */
export const NACHFORDERUNG_EMAIL_ADRESSE = "nachforderungEmailAdresse";

/**
 * Der Ort, an dem im Model ein File Attachment abgespeichert werden soll. Wird als annotation über den
 * PDF-Generierung-Button übergeben.
 */
export const PATH_TO_FILE_ATTACHMENT_LOCATION = PREFIX + "pathToFileAttachmentLocation";

export const STAMMDATEN_MARKER = "stammdaten_marker";

/**
 * modulf_AliasForPath-Annotation für das Feld "Vorgangsnummer"
 */
export const VORGANGSNUMMER = "vorgangsnummer";

/**
 * Annotation für TextCells, die als Infobox dargestellt werden sollen.
 */
export const INFOBOX = PREFIX + "infobox";

/**
 * Annotation für Felder, deren UI-Labels von einem Formatter behandelt werden sollen. Wert ist ein eindeutiger String
 * zur auswahl der passenden Formatierungs-Operation.
 */
export const FORMAT_FIELD = PREFIX + "formatField";

/**
 * Diese Annotation kann an Felder und Gruppen annotiert werden. Wenn ein Element damit annotiert ist, wird es im
 * Falle einer "weak validation" von der Validierung ausgeschlossen.
 * In der Runtime kann eine "weak validation" mit der client-Funktion "weakValidation" aus workflowsUtils ausgeführt
 * werden.
 */
export const WEAK_VALIDATION_MARKER = PREFIX + "weak_validation";

/**
 * Mögliche Werte für weak_validation annotation. Kann dazu genutzt werden, bei Bedarf weak_validation Felder
 * bei einer weak_validation wieder zu inkludieren
 */
export const WEAK_VALIDATION_IDENTIFIERS = {
	GEBUEHRENFORDERUNG: "gebuehrenforderung"
};
/**
 * Annotation für den Veraktungsort.
 */
export const VERAKTUNG_LOCATION = PREFIX + "veraktungLocation";

/**
 * Annotation für den Veraktungstypen.
 */
export const VERAKTUNG_CONTENT_TYPE = PREFIX + "veraktung_content_type";

/**
 * Annotation für Navigation Path
 */
export const NAVIGATION_PATH = PREFIX + "navigation_path";

/**
 * Annotation zu einem Upload-Repeat im Form-Model
 */
export const FILEUPLOAD_FORM_MODEL = PREFIX + "fileupload";
/**
 * Spezifische Annotation zu einem Upload-Repeat mit Unterstützung für "initialAngehaengt"-Flag im Form-Model
 */
export const FILEUPLOAD_INITIAL_ANGEHAENGT_FORM_MODEL = PREFIX + "initialAngehaengt";

/**
 * Annotation, die angibt, welches access-right benötigt wird, um ein Element anzuzeigen
 */
export const VISIBILITY_SCOPE = PREFIX + "visibility_scope";

// Value für gatewayEntscheidung (mf_runtime_navigation_path Annotation)
export const NAVIGATE_WEITER = "WEITER";
export const NAVIGATE_ZURUECKZUMSTART = "ZURUECKZUMSTART";
export const NAVIGATE_ZURUECK = "ZURUECK";

/**
 * Elemente mit dieser Annotation werden ausgeblendet, wenn der aktuelle User nicht die entsprechende Rolle hat.
 * Die Rolle wird im Runtime-Module konfiguriert, dementsprechend ist diese Funktionalität nur Runtime-Modules
 * vorbehalten. Aktuell werden auch nur Form-/Overview-Event-Buttons unterstützt.
 */
export const RUNTIME_MODULE_CHECK_ROLES = PREFIX + "runtimeModuleCheckRoles";

/**
 * Annotation mit A12-Pfad als Wert. Dieser referenziert die document-group in er die Felder
 * des Gebuehrenforderungs-moduls enthalten sind. Der Pfad ist mit dem Modellnamen gepräfixt.
 */
export const GEBUEHRENFORDERUNG_PATH = PREFIX + "gebuehrenforderung_pfad";

/**
 * Annotation mit A12-Pfad als Wert. Dieser referenziert die Document-Group mit xFinanz-Feldern.
 * Der Pfad ist mit dem Modellnamen gepräfixt.
 */
export const XFANANZ_PATH = PREFIX + "xfinanz_pfad";

/**
 * Annotation mit A12-Pfad als Wert. Dieser referenziert die Document-Group mit ePayBL-Feldern.
 * Der Pfad ist mit dem Modellnamen gepräfixt.
 */
export const EPAYBL_ZAHLUNGSVORGANG_PATH = PREFIX + "epaybl_zahlungsvorgang_pfad";

/**
 * Annotation für Controls, deren dargestellter Wert durchgestrichen werden soll, sobald das über den A12-Pfad
 * referenzierte Feld befüllt ist und einen anderen Wert als das Control hat. Wert ist ein A12-Pfad, z.B.
 * A12PATH(toElement=#element).
 */
export const STRIKETHROUGH_DEPENDENT_FIELD = PREFIX + "strikethrough_dependent_field";

/**
 * Annotation, die den Pfad zu einer OpenRegister-Upsert-Gruppe enthält.
 */
export const OPENREGISTER_PATH = PREFIX + "openregister_pfad";

/**
 * Annotation, die als Wert eine Mapping-Configuration-ID enthält.
 */
export const MAPPING_CONFIGURATION = PREFIX + "mapping_configuration";

export const URL_DISPLAY = PREFIX + "urldisplay";

/**
 * Optionaler Anzeigetext für Links, die via {@link URL_DISPLAY} gerendert werden.
 * Ohne diese Annotation wird die URL selbst als Linktext verwendet.
 */
export const URL_DISPLAY_LABEL = PREFIX + "urldisplay_label";

/**
 * Wenn diese Annotation gesetzt ist, wird die URL im Readonly Modus ausgeblendet.
 * Dies ist z.B. für Links zu externen Dokumenten sinnvoll, die nur im Bearbeitungsmodus verfügbar sein sollen.
 */
export const URL_DISPLAY_HIDE_IN_READONLY = PREFIX + "urldisplay_hide_in_readonly";

/**
 * Ein Formmodellfeld mit dieser Annotation wird bei Nutzerzuweisung immer berücksichtigt.
 */
export const COMPONENT = PREFIX + "component";

/**
 * Kann als Annotation in CustomCells verwendet werden, um abhängig vom Wert eine benutzerdefinierte Textanzeige zu realisieren.
 */
export const CUSTOM_TEXT = {
	name: PREFIX + "text",
	values: {
		VERAKTUNGSHINWEISE: "veraktungshinweise"
	}
} as const satisfies ModulfAnnotation;

export const CUSTOM_SCREEN = {
	name: PREFIX + "custom_screen",
	values: {
		ARCHIVE_WIDGET: "archive_widget",
		EXCLUDED_ATTACHMENTS_WARNING: "excluded_attachments_warning"
	}
};

type ModulfAnnotation = {
	name: string;
	values: Record<string, string>;
};

export const INPUT_ANTRAGSDATUM = PREFIX + "input_antragsdatum";
export const OUTPUT_ANTRAGSDATUM = PREFIX + "output_antragsdatum";

/**
 * Eine Annotation auf Buttons zum PDF-Signieren. Bestimmt die Position der visuellen Signatur.
 * Mögliche Werte: ERSTE_SEITE_RECHTS_OBEN, ERSTE_SEITE_RECHTS_UNTEN, LETZTE_SEITE_RECHTS_UNTEN
 */
export const SIGNATUR_POSITION = PREFIX + "signaturPosition";

/**
 * Eine Annotation auf Buttons zum PDF-Signieren.
 * Steuert, ob eine visuelle Signatur (Stempel) in das PDF eingebettet wird ("true" / "false").
 * Wenn nicht gesetzt oder "false", wird nur eine unsichtbare digitale Signatur erzeugt.
 */
export const SIGNATUR_EINBETTEN = PREFIX + "signaturEinbetten";

/**
 * Annotation am Feld {@code transactionId} im DokumentGenerieren-Modul.
 * Enthält die DATA Sign transactionId nach Einreichung des Signierauftrags.
 */
export const TRANSACTION_ID = PREFIX + "print_transactionId";

/**
 * Annotation am Feld {@code signaturStatus} im DokumentGenerieren-Modul.
 * Enthält den aktuellen Status des Signiervorgangs (AUSSTEHEND | SIGNIERT | FEHLGESCHLAGEN).
 */
export const SIGNATUR_STATUS = PREFIX + "print_signaturStatus";
